export default __webpack_public_path__ + "static/media/americanExpress.d97bebc4.svg";